import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-class',
  templateUrl: './class.component.html',
  styleUrls: ['./class.component.css']
})
export class ClassComponent implements OnInit {

  model = { 'table_name': 'class', 'class_id': '0', 'class_name': '', 'class_name_en': '', 'comment': '' };

  Success_Msg; Error_Msg; Class_Name_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<ClassComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Class_Name_Msg').subscribe((res: string) => {
      this.Class_Name_Msg = res;
    });

  }

  ngOnInit() {
    if (this.dialog_data != null)
      this.model = this.dialog_data;
  }

  add() {
    if (this.model['class_name'] != '') {
      let values = [];
      values.push(this.model);

      let obj;
      if (this.model['class_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'class_id': this.model['class_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.dialog_data = {
              'status': data.status['type']
            };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
    else if (this.model['class_name'] == '') {
      alert(this.Class_Name_Msg);
    }
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
